import ProductSerialNumbersHtml from './templates/product-serial-numbers.html';

export function ProductSerialNumbersDirective () {
  return {
    controller: 'ProductSerialNumbersCtrl',
    restrict: 'E',
    templateUrl: ProductSerialNumbersHtml,
    scope: {
      serialNumbers: '=',
      product: '='
    }
  }
};